/* Dokoyo — Find my size
   Satu-satunya sumber logika. demo.html memakai file ini juga.
   Semua perhitungan terjadi di perangkat customer. Tidak ada data yang dikirim ke mana pun.

   Cara pakai:
     <button data-dokoyo-size-guide data-chart="hipster">Find my size</button>
   atau dari kode:
     DokoyoSizeGuide.open('hipster')

   Angka size chart di bawah bersumber dari SIZECHART.md — jangan diubah di sini saja. */
(function(){
  'use strict';

  var CARD_MM = 85.6, CARD_SHORT_MM = 53.98;
  var KEY = 'dokoyo_sg_v1';
  var BORDER = 1.5;                 /* cm — ambang "di perbatasan" */
  /* Cadangan kalau Shopify Inbox tidak ada. Alamat lengkap, bukan '/pages/...':
     halaman kontak dokoyo yang benar adalah contact-us-1 ('/pages/contact' itu 404 —
     ketahuan 30 Agu 2026 karena tombol chat "kosong"), dan alamat lengkap tetap
     benar saat dibuka dari demo Vercel. */
  var CONTACT_URL = 'https://dokoyo.com/pages/contact-us-1';   /* dialihkan ke /id di bawah kalau bahasanya Indonesia */
  var INF = Infinity;

  /* bands = batas ATAS tiap size (rentang rekomendasi)
     raw   = jangkauan asli terkecil–terbesar, untuk cek di luar jangkauan */
  var BOTTOM8 = ['XS','S','M','L','XL','2X','3X','4X'];
  var CHARTS = {
    hipster: {
      label:'Hipster', need:['waist','hips'],
      sizes:['4XS','3XS','2XS','XS','S','M','L','XL','2X','3X','4X'],
      bands:{ waist:[57,62,67,76,85,93,100,107,113,119,INF],
              hips :[70,75,80,88,98,105,113,119,125,131,INF] },
      raw:{ waist:[50,132], hips:[60,147] }
    },
    thong: {
      label:'Thong', need:['waist'], sizes:BOTTOM8,
      bands:{ waist:[76,85,92,100,106,112,118,INF] },
      raw:{ waist:[66,130] }
    },
    midwaist: {
      label:'Midwaist', need:['waist','hips'], sizes:BOTTOM8,
      bands:{ waist:[75,82,89,95,102,108,114,INF],
              hips :[88,95,101,108,114,120,127,INF] },
      raw:{ waist:[66,128], hips:[76,143] }
    },
    /* DULU di sini ada peringatan: "ujung besar atasan SENGAJA masih XXL,
       jangan diubah jadi 2X sekarang" — dengan alasan teks yang dilihat
       pelanggan baru boleh berubah TEPAT SAAT katalog lama diganti, supaya
       popup tidak menyebut 2X sementara toko masih menjual XXL.

       Aturan itu benar. Syaratnya kini TERPENUHI, dan diubah 6 Okt 2026
       justru untuk menegakkannya. Dihitung dari /products.json?limit=250,
       seluruh 172 produk / 1.364 varian:

           XXL  :   0 varian      2X  : 162 varian
           XXS  :   1 varian      2XS :  43 varian

       Katalognya sudah berganti nama. Jadi bahayanya sekarang TERBALIK dari
       yang dikhawatirkan komentar lama: popup menyebut XXL sementara toko
       menjual 2X.

       Dan akibatnya bukan sekadar label yang janggal. sizeAvail() di ~baris
       336 membandingkan nama BARIS TABEL ini dengan daftar varian yang
       dikirim tombolnya lewat data-sizes:

           bralette-blooming-cats  data-sizes="S,M,L,XL,2X"

       normSize('XXL') = 'XXL', tidak ada di daftar itu, jadi scNoSize()
       dipanggil dan pembeli dibalas "Sorry — we don't have your size in this
       one", lalu ditawari obrolan, bukan tombol beli. Padahal 2X dijual.

       Penjaga anyMatch di ~baris 349 tidak menangkapnya: S/M/L/XL cocok,
       jadi penjaganya lolos dan satu nama yang rusak gagal diam-diam.

       Kalau suatu saat katalog memakai nama lain lagi, ubah di EMPAT tempat
       sekaligus: dua daftar `sizes` di berkas ini, `d_rows` di
       snippets/dky-sc-data.liquid, dan nilai bawaan di
       config/settings_schema.json. */
    bralette: {
      label:'Bralette', need:['underbust','bust'], sizes:['S','M','L','XL','2X'],
      bands:{ underbust:[70,76,81,86,INF], bust:[78,84,89,93,INF] },
      raw:{ underbust:[58,98], bust:[68,100] }
    }
  };
  CHARTS.highwaist = Object.assign({}, CHARTS.midwaist, {label:'Highwaist'});
  CHARTS.tubebra   = Object.assign({}, CHARTS.bralette, {label:'Tube Bra'});

  /* ------------------------------------------------------------------
     BAHASA
     Alat ini menggambar semua tulisannya sendiri dari JavaScript, jadi
     Shopify Translate tidak pernah bisa melihatnya. Karena itu naskah
     Indonesianya ditaruh langsung di sini, dipilih dari <html lang>.
     Di /id Shopify menulis lang="id"; di luar itu lang="en".

     Aturan tulis: sapaan santai ("kamu"), sama seperti sisa toko —
     bukan "Anda" yang cuma dipakai halaman kebijakan. Nama potongan
     (Hipster, Thong, Highwaist, Bralette) dan nama size TETAP Inggris,
     karena itu yang tercetak di label produk.

     Cara menambah tulisan baru: tulis `ID ? '<naskah id>' : '<naskah en>'`.
     Jangan memakai kamus cari-ganti — banyak kalimat di sini disusun
     dari potongan ("Your " + bagian + " says " + size), dan urutan kata
     Indonesianya beda, jadi penggantian per-potongan akan kacau.
  ------------------------------------------------------------------ */
  var ID = /^id\b/i.test(document.documentElement.getAttribute('lang') || '');

  /* Halaman kontak cadangan ikut bahasanya — kalau tidak, pelanggan Indonesia
     yang chat-nya gagal dilempar ke halaman kontak berbahasa Inggris. */
  if(ID) CONTACT_URL = 'https://dokoyo.com/id/pages/contact-us-1';

  var LABEL = ID
    ? {waist:'Pinggang', hips:'Pinggul', underbust:'Bawah dada', bust:'Dada'}
    : {waist:'Waist', hips:'Hips', underbust:'Under bust', bust:'Bust'};
  var HOW = ID ? {
    waist:'bagian pinggang kamu yang paling kecil',
    hips:'bagian pinggul kamu yang paling lebar',
    underbust:'tulang rusuk kamu, tepat di bawah dada',
    bust:'bagian dada kamu yang paling penuh'
  } : {
    waist:'the narrowest part of your waist',
    hips:'the fullest part of your hips',
    underbust:'your ribcage, right under your bust',
    bust:'the fullest part of your bust'
  };
  /* "hips" jamak → "say", sisanya "says". Di Indonesia tidak ada beda itu. */
  var VERB = {hips:'say'};
  function verb(k){ return ID ? 'ukurannya' : (VERB[k] || 'says'); }
  /* "an S/M/L/XL" (ess/em/ell/ex) tapi "a 2X/3XS" (two-ex) */
  function art(s){ return /^\d/.test(s) ? 'a' : 'an'; }

  function load(){ try{ return JSON.parse(localStorage.getItem(KEY)) || {}; }catch(e){ return {}; } }
  function save(o){ try{ localStorage.setItem(KEY, JSON.stringify(o)); }catch(e){} }
  var store = load(); if(!store.m) store.m = {};

  /* Tebakan skala layar — HANYA titik awal slider, selalu dikonfirmasi customer.
     Browser tidak pernah tahu ukuran fisik layar; lihat BRIEF.md. */
  function guessPpm(){
    var w = Math.min(screen.width, screen.height), ua = navigator.userAgent;
    if(w <= 500) return /iPhone|iPod/.test(ua) ? 6.05 : 5.30;
    if(w <= 1024 && ('ontouchstart' in window)) return 5.20;
    return 96/25.4;
  }

  function sizeIndex(c,k,cm){ var b=c.bands[k]; for(var i=0;i<b.length;i++) if(cm<=b[i]) return i; return b.length-1; }
  function edge(c,k,cm,i){
    var b=c.bands[k], up=b[i], lo = i===0 ? -INF : b[i-1]+1;
    if(isFinite(up) && cm >= up-BORDER) return 'up';
    if(isFinite(lo) && cm <= lo+BORDER) return 'down';
    return null;
  }
  function outOfRange(c,k,cm){ var r=c.raw[k]; if(cm<r[0]) return 'under'; if(cm>r[1]) return 'over'; return null; }

  /* ---------------------------------------------------------------------
     SATUAN
     Perhitungan di dalam SELALU cm/mm. Yang berubah hanya tampilannya, supaya
     tidak ada pembulatan berlapis yang diam-diam menggeser hasil.
     Pilihan customer dipakai sepanjang proses, bukan cuma di layar hasil.
  --------------------------------------------------------------------- */
  var FRAC = {0:'', 1:'&#8539;', 2:'&frac14;', 3:'&#8540;', 4:'&frac12;',
              5:'&#8541;', 6:'&frac34;', 7:'&#8542;'};
  function isIn(){ return store.unit === 'in'; }
  /* inci dengan pecahan — orang yang berpikir dalam inci membaca 27½", bukan 27,6" */
  function inchStr(cm, den){
    den = den || 8;
    var q = Math.round(cm/2.54*den), whole = Math.floor(q/den), n = q - whole*den, d = den;
    while(n && d > 1 && n % 2 === 0){ n /= 2; d /= 2; }   /* 2/16 → 1/8 */
    var e = n * 8 / d;                                    /* muat jadi perdelapan? */
    /* Pecahan seperseparuh, seperempat, perdelapan punya lambangnya sendiri.
       Yang lebih halus (13/16) ditulis apa adanya — memaksanya jadi ⅞ akan
       menggeser hasil 1,6 mm tanpa ada yang menyadari. */
    var f = (e === Math.round(e)) ? FRAC[e] : (n+'/'+d);
    if(!whole && !f) return '0&quot;';
    return whole + (f ? ' '+f : '') + '&quot;';
  }
  /* jangan bulatkan ke satuan cm — 92,5 tampil jadi 93 bikin customer mengira alatnya salah baca */
  function fmt(cm){ return cm.toFixed(1).replace(/\.0$/,''); }
  function cmStr(cm){ return fmt(cm)+' cm'; }
  /* satuan pilihan di depan, satunya sebagai pendamping */
  function both(cm){
    return isIn() ? inchStr(cm,8)+' &middot; '+cmStr(cm) : cmStr(cm)+' &middot; '+inchStr(cm,8);
  }
  /* hanya satuan pilihan — untuk baris ringkas seperti "Waist 71 cm · Hips 94 cm" */
  function disp(cm){ return isIn() ? inchStr(cm,8) : cmStr(cm); }
  /* sisa terakhir, dibaca lebih halus: milimeter atau inci per 1/16 */
  function dispFine(mm){ return isIn() ? inchStr(mm/10,16) : Math.round(mm)+' mm'; }
  function unitLabel(){ return isIn() ? 'in' : 'cm'; }
  function toCm(n){ return isIn() ? n*2.54 : n; }
  function fromCm(cm){ return isIn() ? cm/2.54 : cm; }

  /* ---------------------------------------------------------------------
     GAMBAR BERGERAK
     Menggantikan instruksi bertele-tele. Ditulis sebagai SVG di dalam kode —
     tidak ada file yang dimuat, tidak ada biaya, dan tetap tajam di layar apa pun.
     Gaya sengaja garis tegas tanpa model, sesuai arahan desain.
     Kalau desainer nanti menggambar ulang, cukup ganti isi <path>-nya;
     kelas animasinya (a-draw, a-step, dan seterusnya) biarkan.
  --------------------------------------------------------------------- */
  /* Posisi lingkar dalam koordinat croquis aslinya. Angkanya bukan tebakan — siluetnya
     disampel titik demi titik lalu diukur: pinggang = bagian tersempit (y 2700),
     pinggul = bagian terlebar tepat di atas selangkangan (y 4350), dan lingkar dada
     mengikuti lengkung bawah dada yang digambar desainer. */
  /* Ukuran yang sudah punya ilustrasi berwarna. Tambahkan barisnya saat gambar baru
     masuk: hips:'hips', bust:'bust', underbust:'underbust' — tidak ada kode lain
     yang perlu diubah. Selama masih kosong, ukuran itu memakai croquis garis. */
  /* Keempat lukisan Higgsfield lengkap sejak 30 Agu 2026 — croquis kini hanya
     cadangan kalau ada ukuran baru yang belum punya gambar. */
  var PHOTO_BODY = { waist:'waist', hips:'hips', bust:'bust', underbust:'underbust' };

  var BAND = {
    bust:      {cy:1650, rx:900},
    underbust: {cy:1950, rx:840},
    waist:     {cy:2700, rx:672},
    hips:      {cy:4350, rx:1145}
  };
  /* Torso bergaya croquis mengikuti ilustrasi acuan Pryambudi: garis tipis, bahu
     melandai, lengan ada (dipotong sebelum pergelangan tangan), lengkung bawah dada,
     pinggang menyempit, pinggul melebar. Kepala tidak digambar.
     Siluet SENGAJA TERBUKA — tidak ada satu pun garis penutup. Leher, pergelangan
     tangan, dan kaki hanya terputus di tepi gambar, persis seperti croquis acuan.
     Menutupnya akan membuat sosoknya terlihat seperti benda, bukan orang yang
     gambarnya kebetulan dipotong. */
  /* Croquis buatan desainer Dokoyo (ekspor CorelDRAW, Untitled-1.svg).
     Dipakai apa adanya — JANGAN digambar ulang. Semua ukuran lingkar di bawah
     memakai sistem koordinat aslinya. */
  var BODY_VB = '0 0 3290.39 5650.81';
  var BODY = '<path class="ink" d="M1348.97 14.46c0,0 43.38,230.46 -127.43,271.13 -170.81,40.67 -637.16,170.81 -637.16,170.81 0,0 -281.98,24.4 -319.94,517.86 -37.96,493.46 -75.91,1645.77 -75.91,1645.77 0,0 -159.96,536.84 -168.1,664.27 -8.13,127.43 -10.85,916.42 10.84,1114.35 21.69,197.93 21.69,268.42 21.69,268.42m2569.64 -3383.75c0,0 46.09,250.8 -82.7,390.43 -128.79,139.63 -214.19,170.81 -413.48,165.39 -199.28,-5.42 -347.06,-122 -385.01,-352.46m44.77 2869.92c0,0 -64.39,115.91 -140.99,115.91m125.4 1155.7c0,0 -32.54,-512.44 -40.67,-650.71 -8.13,-138.28 -18.98,-531.42 -18.98,-531.42m1279.75 229.13c0,0 -162.68,-854.07 -208.77,-1130.62 -46.09,-276.55 -40.67,-534.13 -35.25,-618.18 5.42,-84.05 -8.13,-100.32 -32.54,-265.71 -24.4,-165.39 -120.66,-562.6 -142.35,-753.75 -21.69,-191.15 -21.69,-214.19 -21.69,-214.19 0,0 -46.09,248.09 -97.61,403.99 -51.51,155.9 -184.37,600.55 -117.94,757.81 66.43,157.26 315.87,581.57 360.6,817.46 44.74,235.88 140.99,516.51 86.76,1210.6 -54.23,694.09 -75.92,753.74 -75.92,753.74m-764.58 -5621.88c0,0 -43.38,230.46 127.43,271.13 170.81,40.67 637.16,170.81 637.16,170.81 0,0 281.98,24.4 319.94,517.86 37.96,493.46 75.91,1645.77 75.91,1645.77 0,0 159.96,536.84 168.1,664.27 8.13,127.43 10.85,916.42 -10.84,1114.35 -21.69,197.93 -21.69,268.42 -21.69,268.42m-2569.64 -3383.75c0,0 -46.09,250.8 82.7,390.43 128.79,139.63 214.19,170.81 413.48,165.39 199.28,-5.42 347.06,-122 385.01,-352.46m-44.77 2869.92c0,0 64.39,115.91 140.99,115.91m-125.4 1155.7c0,0 32.54,-512.44 40.67,-650.71 8.13,-138.28 18.98,-531.42 18.98,-531.42m-1279.75 229.13c0,0 162.68,-854.07 208.77,-1130.62 46.09,-276.55 40.67,-534.13 35.25,-618.18 -5.42,-84.05 8.13,-100.32 32.54,-265.71 24.4,-165.39 120.66,-562.6 142.35,-753.75 21.69,-191.15 21.69,-214.19 21.69,-214.19 0,0 46.09,248.09 97.61,403.99 51.51,155.9 184.37,600.55 117.94,757.81 -66.43,157.26 -315.87,581.57 -360.6,817.46 -44.74,235.88 -140.99,516.51 -86.76,1210.6 54.23,694.09 75.92,753.74 75.92,753.74"/>';

  /* Tali melingkari badan, jadi separuh belakangnya tertutup tubuh. Digambar sebagai
     dua busur: yang belakang samar, yang depan tegas — kesannya badan agak tembus
     pandang, dan arah lingkarnya jadi langsung terbaca. */
  /* Tali melingkar dalam satu putaran berurutan, bukan dua busur yang muncul bersamaan:
     depan digambar dulu dari KANAN ke KIRI, setelah selesai barulah bagian belakang
     berlanjut dari KIRI ke KANAN. Keduanya searah jarum jam, jadi terbaca sebagai satu
     gerakan melingkari badan. Yang belakang dibuat samar seolah tertutup tubuh.
     pathLength="100" menyamakan kecepatan menggambar untuk lingkar besar maupun kecil. */
  function loop(cx, cy, rx, ry){
    var l = (cx-rx)+','+cy, r = (cx+rx)+','+cy, a = 'A'+rx+','+ry+' 0 0,1 ';
    return '<path class="hot a-arc-front" pathLength="100" d="M'+r+' '+a+l+'"/>'+
           '<path class="hot faded a-arc-back" pathLength="100" d="M'+l+' '+a+r+'"/>';
  }

  var ART = {
    /* dua benda yang harus disiapkan: tali dan kartu */
    gather: function(){
      return '<svg class="sg-art" viewBox="0 0 280 116" aria-hidden="true">'+
        '<g class="a-bob">'+
          '<path class="ink" d="M22,50 C40,28 56,72 74,50 C86,36 102,64 114,50"/>'+
          '<circle class="hotfill" cx="22" cy="50" r="4"/>'+
          '<circle class="hotfill" cx="114" cy="50" r="4"/>'+
        '</g>'+
        '<text class="lbl" x="68" y="98" text-anchor="middle">something bendy</text>'+
        '<rect class="card" x="168" y="24" width="82" height="52" rx="5"/>'+
        '<path class="hot" d="M178,62 h30" stroke-width="4"/>'+
        '<rect class="hotfill" x="178" y="36" width="20" height="14" rx="2" opacity=".55"/>'+
        '<text class="lbl" x="209" y="98" text-anchor="middle">any bank card</text>'+
      '</svg>';
    },

    /* tali yang boleh vs karet yang menipu */
    string: function(){
      /* Kedua panel dipusatkan pada x yang sama dengan labelnya (70 dan 210),
         dan diberi jarak vertikal supaya gambar tidak menempel ke tulisan. */
      return '<svg class="sg-art" viewBox="0 0 280 116" aria-hidden="true">'+
        '<g class="a-bob">'+
          '<path class="ink" d="M24,48 C42,26 58,70 76,48 C88,34 104,62 116,48"/>'+
          '<circle class="hotfill" cx="24" cy="48" r="4"/>'+
          '<circle class="hotfill" cx="116" cy="48" r="4"/>'+
        '</g>'+
        '<path class="hot" d="M62,84 l7,7 l12,-16"/>'+
        '<text class="lbl" x="70" y="110" text-anchor="middle">bendy</text>'+
        '<g class="a-stretch"><path class="softline" d="M182,48 L238,48"/></g>'+
        '<path class="hot" d="M203,82 l14,14 M217,82 l-14,14"/>'+
        '<text class="lbl" x="210" y="110" text-anchor="middle">stretchy</text>'+
      '</svg>';
    },

    /* Ilustrasi berwarna dipakai kalau tersedia untuk ukuran itu; sisanya jatuh ke
       croquis garis. Begitu `pinggul`, `dada`, dan `bawah-dada` masuk, cukup tambahkan
       namanya ke PHOTO_BODY di bawah dan seluruh alur otomatis memakai lukisan. */
    body: function(k){
      if(PHOTO_BODY[k]) return '<div class="photo photo-body photo-'+PHOTO_BODY[k]+'" aria-hidden="true"></div>';
      var b = BAND[k] || BAND.waist;
      /* Labelnya sengaja di luar SVG (lihat scMeasure) — kalau ditaruh di dalam,
         posisinya ikut berpindah bersama lingkar dan menabrak garis badan. */
      var ry = Math.round(b.rx * 0.11);      /* pipih mengikuti perspektif */
      return '<svg class="sg-art model" viewBox="'+BODY_VB+'" aria-hidden="true">'+
        BODY +
        loop(1645, b.cy, b.rx, ry)+
        '<circle class="hotfill a-pulse" cx="1645" cy="'+(b.cy+ry)+'" r="75"/>'+
      '</svg>';
    },

    /* kartu melangkah di sepanjang tali, tanda hitungan menyala satu per satu */
    /* Adegan bergambar dari desainer: tangan menggeser kartu di sepanjang kabel.
       Angka berjalan ikut menyala satu per satu supaya "hitung dengan suara keras"
       punya padanan yang terlihat. Penempatannya diatur di CSS (.scene). */
    count: function(){
      var xs = [16,29,42,55,68], chips = '';
      for(var i=0;i<5;i++){
        chips += '<span class="scene-n n'+(i+1)+'" style="left:'+xs[i]+'%">'+(i+1)+'</span>';
      }
      return '<div class="scene" aria-hidden="true">'+
        '<div class="scene-track"></div>'+
        '<div class="scene-mark"></div>'+ chips +
        '<div class="scene-hand"></div>'+
      '</div>';
    }
  };

  var S = { chart:null, queue:[], cur:null, cards:null, screen:null, arg:null, hist:[] };
  var $sg, $mask, $body, $step, $top, $back;

  /* host = null → popup biasa (halaman produk).
     host = elemen → mode MENYATU untuk halaman "find my size" tersendiri:
     rangkanya sama persis, cuma tidak melayang dan tanpa tombol tutup. Layar
     penggaris tetap memakai seluruh layar (kelas .locked) karena memang butuh
     tinggi penuh — itu benar, bukan kecelakaan. */
  function build(host){
    if($sg) return;
    var root = document.createElement('div');
    /* Kelas gaya dipasang selalu — hanya ada satu tampilan, mengikuti tema toko.
       Huruf TIDAK diunduh dari luar: diwarisi dari tema lewat CSS. */
    root.className = 'dokoyo-sg-root theme-jacquemus' + (host ? ' sg-inline' : '');
    root.innerHTML =
      '<div class="sg-mask"></div>'+
      /* tabindex="-1" supaya dialognya BISA menerima fokus lewat skrip.
         Tanpa ini, fokus tidak pernah masuk ke dalam dialog dan pengguna
         papan ketik harus menekan Tab 76 kali untuk sampai ke tombol tutup -
         diukur di halaman produk hidup, 2 Okt 2026. */
      '<div class="sg" role="dialog" aria-modal="true" tabindex="-1" aria-label="'+
          (ID?'Cari size aku':'Find my size')+'">'+
        '<div class="sg-top">'+
          '<button class="sg-back" aria-label="'+(ID?'Kembali':'Back')+'">&larr;</button>'+
          '<div class="sg-step"></div>'+
          '<button class="sg-x" aria-label="'+(ID?'Tutup':'Close')+'">&times;</button></div>'+
        '<div class="sg-body"></div>'+
        /* 9 kotak 1px tersembunyi — memicu unduhan SEMUA gambar begitu popup pertama
           kali dibangun, jadi di koneksi lambat layar berikutnya tidak menunggu
           gambar. Daftar gambarnya ada di CSS (.sg-preload). */
        '<div class="sg-preload" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></div>'+
      '</div>';
    (host || document.body).appendChild(root);
    S.inline = !!host;
    $mask = root.querySelector('.sg-mask');
    $sg   = root.querySelector('.sg');
    $top  = root.querySelector('.sg-top');
    $step = root.querySelector('.sg-step');
    $body = root.querySelector('.sg-body');
    $back = root.querySelector('.sg-back');
    root.querySelector('.sg-x').onclick = close;
    $back.onclick = back;
    $mask.onclick = close;
  }

  /* Riwayat layar — tiap langkah bisa dibatalkan. Tanpa ini, satu salah ketuk
     memaksa customer mengulang dari awal, dan itu titik di mana orang menyerah. */
  function back(){
    if(!S.hist.length) return;
    var p = S.hist.pop();
    go(p.name, p.arg, true);
  }
  /* Nama size disamakan dulu sebelum dibandingkan: "2 XS" / "2xs" / "2-XS" → "2XS" */
  /* ====================================================================
     SATU UKURAN, BANYAK EJAAN
     ====================================================================
     Katalog toko ini memakai TIGA konvensi penamaan sekaligus. Dihitung dari
     /products.json?limit=250 pada 6 Okt 2026, 172 produk / 1.364 varian:

         2X  162 varian      2XL  (11 produk Tencel)
         2XS  43 varian      3XL / 4XL (3 produk Tencel)
                             XXS  ( 1 varian tersisa)

     sizeAvail() di bawah membandingkan nama BARIS TABEL dengan daftar varian
     yang dikirim tombolnya lewat data-sizes. Kalau ejaannya beda, pembeli
     dibalas scNoSize() - "Sorry, we don't have your size in this one" -
     dan ditawari obrolan, bukan tombol beli, padahal ukurannya DIJUAL.

     Itu sudah terjadi sekali dengan XXL vs 2X dan baru diperbaiki hari ini
     dengan menyelaraskan nama tabel. Tapi menyelaraskan nama saja rapuh:
     begitu ada produk baru dengan ejaan lain, bug yang sama kembali diam-diam.

     Jadi pencocoknya yang dibuat memaafkan. Tabel di bawah menyatukan ejaan
     yang BERARTI SAMA, dan sengaja ditulis eksplisit, bukan regex: aturan
     berpola gampang menelan XL jadi 1X, atau menyamakan 2XS (kecil) dengan
     2X (besar) - dua ukuran yang berlawanan.
     ==================================================================== */
  var EJAAN_SAMA = {
    XXL: '2X',  XXXL: '3X',  XXXXL: '4X',
    '2XL': '2X', '3XL': '3X', '4XL': '4X',
    XXS: '2XS', XXXS: '3XS', XXXXS: '4XS'
  };

  function normSize(s){
    var n = String(s).toUpperCase().replace(/[^0-9A-Z]/g,'');
    return EJAAN_SAMA[n] || n;
  }
  function sizeAvail(name){ return !S.avail || S.avail.indexOf(normSize(name)) > -1; }

  function open(chartKey, sizesCsv){
    build();
    if(!CHARTS[chartKey]){ chartKey = 'hipster'; }
    /* Daftar varian size yang BENAR-BENAR dijual produk ini, dikirim tombolnya
       lewat data-sizes (permintaan Nandha 30 Agu: tabel memuat 4XS-4X, produk
       tidak; jangan merekomendasikan size yang tak bisa dibeli).
       Pengaman: kalau tidak ada SATU PUN nama tabel yang cocok dengan daftar itu,
       berarti konvensi namanya beda — daftar diabaikan, jangan menolak semua orang. */
    S.avail = null;
    if(sizesCsv){
      var av = String(sizesCsv).split(',').map(normSize).filter(Boolean);
      var anyMatch = CHARTS[chartKey].sizes.some(function(s){ return av.indexOf(normSize(s)) > -1; });
      if(av.length && anyMatch) S.avail = av;
    }
    /* baca ulang penyimpanan tiap kali dibuka — kalau customer mengukur di tab lain, atau
       penyimpanan belum siap saat halaman dimuat, salinan di memori bisa basi dan
       customer disuruh mengukur ulang padahal datanya sudah ada */
    var fresh = load(); if(fresh && fresh.m) store = fresh;
    if(!store.m) store.m = {};

    S.chart = CHARTS[chartKey]; S.chartKey = chartKey;
    S.hist = []; S.screen = null; S.arg = null;
    $sg.classList.add('on');
    if(!S.inline){
      $mask.classList.add('on');
      document.body.style.overflow = 'hidden';
      /* Siapa yang membuka - supaya fokus bisa dikembalikan ke sana saat
         ditutup. Tanpa ini pengguna papan ketik terlempar ke awal halaman. */
      S.pemicu = document.activeElement;
      pasangPerangkapFokus();
    }
    var have = S.chart.need.filter(function(k){ return store.m[k] != null; });
    if(have.length === S.chart.need.length) go('returning');
    else if(have.length) go('partial');
    else go('intro');
  }
  function close(){
    releaseLock();
    var stale = document.getElementById('rWrap'); if(stale) stale.remove();
    $sg.classList.remove('locked'); $top.style.display=''; $body.style.display='';
    /* Menyatu di halaman: tidak ada yang bisa "ditutup" — kembalikan saja ke
       grid pemilih model, supaya "Got it" tetap punya arti di sana. */
    if(S.inline){ showPicker(); return; }
    $mask.classList.remove('on'); $sg.classList.remove('on');
    document.body.style.overflow = '';
    lepasPerangkapFokus();
    /* Kembalikan fokus ke tombol yang membukanya. Kalau tombol itu sudah
       hilang dari halaman, jangan paksakan - biarkan peramban. */
    try {
      if (S.pemicu && document.contains(S.pemicu)) S.pemicu.focus();
    } catch (e) {}
    S.pemicu = null;
  }

  /* ====================================================================
     PERANGKAP FOKUS DAN ESC
     ====================================================================
     Diukur di halaman produk hidup pada 1440x900 (2 Okt 2026), dialog
     dibuka dengan klik tetikus sungguhan:

         fokus sesudah dibuka  : masih di tombol pemicu, di LUAR dialog
         Tab 14 kali           : 14 dari 14 mendarat di luar dialog
         Tab sampai tombol tutup: 76 kali
         Esc ditekan 2 kali    : dialog tidak berubah sama sekali
         cincin fokus          : digambar di BAWAH tirai, jadi tak terlihat

     Artinya pengguna papan ketik yang membuka panduan ukuran tidak bisa
     memakainya dan tidak bisa menutupnya. Tirai memang bisa diklik untuk
     menutup, tapi itu hanya menolong pengguna tetikus.

     Polanya mengikuti snippets/dky-tawaran-bahasa.liquid (~baris 576):
     Esc menutup, Tab berputar di dalam dialog, fokus kembali ke pemicu.
     ==================================================================== */
  function elemenBisaFokus(){
    if(!$sg) return [];
    var pilih = 'a[href],button:not([disabled]),input:not([disabled]),' +
                'select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call($sg.querySelectorAll(pilih), function(el){
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    });
  }

  function tanganiTombol(ev){
    if(!$sg || !$sg.classList.contains('on')) return;

    if(ev.key === 'Escape' || ev.key === 'Esc'){
      ev.preventDefault();
      close();
      return;
    }

    if(ev.key !== 'Tab') return;

    var daftar = elemenBisaFokus();
    if(!daftar.length){
      /* Tidak ada yang bisa difokus di dalam - tahan fokus di dialognya
         sendiri supaya tidak melompat ke halaman di belakang. */
      ev.preventDefault();
      $sg.focus();
      return;
    }
    var pertama = daftar[0], terakhir = daftar[daftar.length - 1];
    var aktif = document.activeElement;

    if(!$sg.contains(aktif)){
      ev.preventDefault();
      (ev.shiftKey ? terakhir : pertama).focus();
      return;
    }
    if(ev.shiftKey && aktif === pertama){
      ev.preventDefault(); terakhir.focus();
    } else if(!ev.shiftKey && aktif === terakhir){
      ev.preventDefault(); pertama.focus();
    }
  }

  function pasangPerangkapFokus(){
    document.addEventListener('keydown', tanganiTombol, true);
    /* Fokus dipindah sesudah satu putaran gambar, supaya isi layarnya sudah
       ada - go() mengisi $body setelah baris ini dipanggil. */
    setTimeout(function(){
      if(!$sg || !$sg.classList.contains('on')) return;
      var daftar = elemenBisaFokus();
      try { (daftar.length ? daftar[0] : $sg).focus(); } catch (e) {}
    }, 60);
  }

  function lepasPerangkapFokus(){
    document.removeEventListener('keydown', tanganiTombol, true);
  }

  function setStep(t){ $step.textContent = t || ''; }
  function html(s){ $body.innerHTML = s; }
  function on(id, fn){ var el = document.getElementById(id); if(el) el.onclick = fn; }

  function go(name, arg, isBack){
    /* bersihkan sisa layar penggaris apa pun jalan keluarnya */
    var stale = document.getElementById('rWrap');
    if(stale){ releaseLock(); stale.remove(); }
    if(!isBack && S.screen) S.hist.push({name:S.screen, arg:S.arg});
    S.screen = name; S.arg = arg;
    $sg.classList.remove('locked'); $top.style.display=''; $body.style.display='';
    $back.classList.remove('on');          /* tombol kembali sekarang menempel tombol lanjut */
    ({ intro:scIntro, string:scString, measure:scMeasure, count:scCount,
       ruler:scRuler, estimate:scEstimate, single:scSingle,
       final:scFinal, manual:scManual, returning:scReturning, partial:scPartial })[name](arg);
    attachBack();
    $body.scrollTop = 0;
  }

  /* Sisipkan tombol kembali tepat di samping tombol utama tiap layar, tanpa perlu
     mengubah satu per satu layarnya. Kalau tidak muat sebaris, CSS menurunkannya. */
  function attachBack(){
    if(!S.hist.length) return;
    var main = $body.querySelector('.btn:not(.ghost)');
    if(!main || main.closest('.sg-nav')) return;
    var row = document.createElement('div');
    row.className = 'sg-nav';
    main.parentNode.insertBefore(row, main);
    row.appendChild(main);                 /* tombol utama dulu → tampil di kanan */
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'btn ghost sg-navback';
    b.innerHTML = ID ? '&larr; Kembali' : '&larr; Back';
    b.onclick = back;
    row.appendChild(b);
  }

  function scIntro(){
    setStep('');
    html((ID
      ? '<h2>Nggak punya meteran? Sama.</h2>'+
        '<div class="photo photo-hello" aria-hidden="true"></div>'+
        '<p class="lede">Modalnya cuma seutas tali dan satu kartu ATM.<br>Dua menit, paling lama.</p>'+
        '<p class="quiet" style="margin-bottom:6px">Tampilkan semuanya dalam</p>'+
        '<div class="unitpick">'+
          '<button id="uCm"'+(isIn()?'':' class="on"')+'>sentimeter</button>'+
          '<button id="uIn"'+(isIn()?' class="on"':'')+'>inci</button>'+
        '</div>'+
        '<button class="btn" id="b1">Ayo mulai</button>'+
        '<div class="links"><button class="link" id="b2">Aku sudah tahu ukuranku &rarr;</button></div>'+
        '<p class="tiny">Ukuran kamu tidak pernah keluar dari HP ini. Kami tidak bisa melihatnya.</p>'
      : '<h2>No measuring tape? Same.</h2>'+
        '<div class="photo photo-hello" aria-hidden="true"></div>'+
        '<p class="lede">All you need is a piece of string and a bank card.<br>Two minutes, tops.</p>'+
        '<p class="quiet" style="margin-bottom:6px">Show everything in</p>'+
        '<div class="unitpick">'+
          '<button id="uCm"'+(isIn()?'':' class="on"')+'>centimetres</button>'+
          '<button id="uIn"'+(isIn()?' class="on"':'')+'>inches</button>'+
        '</div>'+
        '<button class="btn" id="b1">Let\'s go</button>'+
        '<div class="links"><button class="link" id="b2">I already know my measurements &rarr;</button></div>'+
        '<p class="tiny">Your measurements never leave this device. We don\'t see them.</p>'));
    function pick(u){ store.unit = u; save(store); go('intro', null, true); }
    on('uCm', function(){ pick('cm'); });
    on('uIn', function(){ pick('in'); });
    on('b1', function(){ S.queue = S.chart.need.slice(); go('string'); });
    on('b2', function(){ go('manual'); });
  }

  function scString(){
    setStep('');
    html((ID
      ? '<h2>Siapkan tali dan kartu ATM</h2>'+
        '<div class="photo photo-gather" aria-hidden="true"></div>'+
        '<p>Talinya bebas: tali sepatu, pita, atau kabel charger juga bisa.</p>'+
        '<p class="quiet">Yang penting bisa dilekukkan tapi tidak melar. Karet pasti bohong.</p>'+
        '<button class="btn" id="b1">Sudah siap</button>'
      : '<h2>Grab a string and a bank card</h2>'+
        '<div class="photo photo-gather" aria-hidden="true"></div>'+
        '<p>For the string: a shoelace, ribbon, or charger cable will do.</p>'+
        '<p class="quiet">Anything that bends but doesn\'t stretch. Elastic will lie to you.</p>'+
        '<button class="btn" id="b1">Got it</button>'));
    on('b1', function(){ S.cur = S.queue[0]; go('measure'); });
  }

  function stepLabel(){
    var total = S.chart.need.length, i = S.chart.need.indexOf(S.cur)+1;
    return (total>1 ? (ID ? 'Langkah '+i+' dari '+total+' · ' : 'Step '+i+' of '+total+' · ') : '') + LABEL[S.cur];
  }

  function scMeasure(){
    setStep(stepLabel());
    var extra = (S.chart.need.length>1 && S.chart.need.indexOf(S.cur)===1)
      ? '<p class="quiet">'+(ID
          ? 'Satu lagi dan selesai. Tali dan kartu yang sama.'
          : 'One more and you\'re done. Same string, same card.')+'</p>' : '';
    /* Animasi menunjukkan GERAKANNYA; dua baris teks di bawah menjaga KETELITIANNYA.
       "Muat satu jari" tidak bisa digambar — tanpa kalimat itu tiap orang menarik
       dengan kekencangan berbeda dan hasilnya meleset beberapa cm. */
    html(extra+(ID
      ? '<h2>Lingkarkan talinya di '+HOW[S.cur]+'</h2>'+
        ART.body(S.cur)+
        '<p class="artcap">Tandai titik tali bertemu</p>'+
        '<p class="quiet" style="text-align:center;margin-top:-10px">'+
          'Boleh dicoret pulpen, dilipat, ditempel selotip &mdash; atau cukup dijepit pakai jari.</p>'+
        '<p>Pas di badan, tapi jangan ditarik kencang &mdash; masih muat satu jari di bawahnya.</p>'+
        '<button class="btn" id="b1">Sudah aku pegang</button>'
      : '<h2>Wrap it around '+HOW[S.cur]+'</h2>'+
        ART.body(S.cur)+
        '<p class="artcap">Mark the spot where it meets</p>'+
        '<p class="quiet" style="text-align:center;margin-top:-10px">'+
          'A pen mark, a fold in the paper, a bit of tape &mdash; or just pinch it and hold.</p>'+
        '<p>Snug, but not squeezing &mdash; still room for one finger underneath.</p>'+
        '<button class="btn" id="b1">I\'m holding it</button>'));
    on('b1', function(){ S.cards = null; go('count'); });
  }

  function scCount(){
    setStep(stepLabel());
    html((ID
      ? '<h2>Jalankan kartunya di sepanjang tali</h2>'+
        ART.count()+
        '<p>Bentangkan talinya, tandai titik jepitannya, lalu jalankan kartu ATM ujung ke ujung.</p>'+
        '<p class="quiet">Hitung dengan suara keras &mdash; lebih gampang lupa daripada yang kamu kira.</p>'+
        '<p class="quiet" style="margin-bottom:2px">Dapat berapa kartu penuh?</p>'+
        '<div class="counter"><button id="cMinus" aria-label="Kurangi satu">&minus;</button>'+
          '<div class="val empty" id="cVal">&ndash;</div>'+
          '<button id="cPlus" aria-label="Tambah satu">+</button></div>'+
        '<p class="quiet" id="cWarn" style="display:none;color:#a34426">'+
          'Dapat berapa kartu penuh tadi?</p>'+
        '<button class="btn" id="b1">Lanjut: sisa talinya</button>'
      : '<h2>Walk your card along it</h2>'+
        ART.count()+
        '<p>Lay the string flat, mark the pinch, then step your bank card end over end.</p>'+
        '<p class="quiet">Count out loud &mdash; it\'s easier to lose track than you\'d think.</p>'+
        '<p class="quiet" style="margin-bottom:2px">How many full cards?</p>'+
        '<div class="counter"><button id="cMinus" aria-label="One less">&minus;</button>'+
          '<div class="val empty" id="cVal">&ndash;</div>'+
          '<button id="cPlus" aria-label="One more">+</button></div>'+
        '<p class="quiet" id="cWarn" style="display:none;color:#a34426">'+
          'How many full cards did you count?</p>'+
        '<button class="btn" id="b1">Next: the leftover bit</button>'));
    var v = document.getElementById('cVal'), w = document.getElementById('cWarn');
    function draw(){
      if(S.cards==null){ v.textContent='–'; v.classList.add('empty'); }
      else { v.textContent = S.cards; v.classList.remove('empty'); w.style.display='none'; }
    }
    on('cMinus', function(){ if(S.cards!=null && S.cards>0) S.cards--; draw(); });
    on('cPlus',  function(){ S.cards = (S.cards==null?1:S.cards+1); draw(); });
    on('b1', function(){
      if(S.cards==null){ w.style.display=''; return; }
      go('ruler');
    });
    draw();
  }

  var wakeLock = null;
  function blockTouch(e){ if(e.cancelable) e.preventDefault(); }
  function releaseLock(){
    if(wakeLock){ try{ wakeLock.release(); }catch(e){} wakeLock = null; }
    document.removeEventListener('touchmove', blockTouch, {passive:false});
  }
  function zoomSuspect(){
    var vv = window.visualViewport;
    if(vv && Math.abs(vv.scale-1) > 0.02) return true;
    if(store.dpr && Math.abs(window.devicePixelRatio - store.dpr) > 0.01) return true;
    return false;
  }

  function scRuler(){
    $sg.classList.add('locked'); $top.style.display='none';

    /* Ukur dari elemen dulu, innerHeight cuma cadangan. Di sebagian in-app browser
       innerHeight bisa 0 — dan penggaris yang kehabisan ruang akan diam-diam mengunci
       pembacaan di 0 mm, yaitu salah tanpa tanda. */
    var vh = Math.round($sg.getBoundingClientRect().height) ||
             window.innerHeight || document.documentElement.clientHeight || 0;
    var ppm = store.ppm || guessPpm();
    var maxMm = (vh - 250)/ppm;            /* 250 = kepala + slider + kaki layar */
    if(!(maxMm >= 30)){                    /* menangkap 0, negatif, dan NaN sekaligus */
      $sg.classList.remove('locked'); $top.style.display='';
      go('estimate','noroom'); return;
    }
    cardRuler(ppm);
  }

  /* Penggaris kartu — SATU layar untuk dua pekerjaan, dengan SATU kotak yang sama.
     Tahap "match": customer menempelkan kartu aslinya ke kotak dan menggeser slider
     sampai kotaknya pas — itulah kalibrasi, tanpa layar terpisah.
     Tahap "measure": kotak yang barusan dicocokkan dipakai mengukur sisa tali.
     Layar kalibrasi lama dan mode penggaris bergaris DIHAPUS (2026-08-29): dua alat
     yang harus dipahami terbukti membingungkan; satu benda yang sama tidak. */
  function cardRuler(startPpm){
    var ppm = startPpm, base = startPpm, LO = 0.55, val = 20;
    html(''); $body.style.display = 'none';
    $sg.insertAdjacentHTML('beforeend',
      '<div class="cardruler" id="rWrap">'+
        '<div class="cr-head">'+
          '<div class="cr-match-head">'+
            '<div class="cr-match-title">'+(ID
              ? 'Pertama, kenalkan kartumu ke layar'
              : 'First, teach the screen your card')+'</div>'+
            '<div class="cr-match-desc">'+(ID
              ? 'Tempelkan kartu ATM-mu di layar, pas di atas kotaknya &mdash; '+
                'lalu geser slider sampai kotaknya <b>persis</b> sebesar kartumu.<br>'+
                'Kartu apa pun bisa. Ukurannya sama di seluruh dunia.'
              : 'Put your card flat on the screen, over the box &mdash; '+
                'then drag the slider until the box is <b>exactly</b> the size of your card.<br>'+
                'Any card works. They\'re all the same size, everywhere on Earth.')+'</div>'+
          '</div>'+
          '<div class="cr-head-top">'+
            '<div style="width:94px;flex:none"></div>'+
            '<div class="cr-read" id="rRead">20 mm</div>'+
            '<div class="cr-nudge"><button id="rDown">&minus;</button><button id="rUp">+</button></div>'+
          '</div>'+
          '<div class="cr-head-desc">'+(ID
            ? 'taruh talinya di atas kartu, ujung atas di angka 0 &mdash; lalu geser garisnya ke ujung tali'
            : 'lay your string on the card, top edge at 0 &mdash; then slide the line to its end')+'</div>'+
        '</div>'+
        (zoomSuspect() ? '<div class="warn">'+(ID
          ? 'Halamannya ter-zoom? Penggarisnya bisa meleset.'
          : 'Did the page zoom? Your ruler might be off.')+'</div>' : '')+
        '<div class="cr-stage" id="rStage">'+
          '<div class="cr-card" id="rCard">'+
            '<div class="cr-card-inner"><div class="cr-fill" id="rFill"></div></div>'+
            '<div class="cr-zero">0</div>'+
            '<div class="cr-line" id="rLine"><div class="cr-drag-hint">'+
              (ID?'geser ini':'drag this')+'</div><b id="rTag"></b><div class="cr-dot"></div></div>'+
            /* Tangan bayangan: satu gambar utuh editan Nandha (CorelDRAW, 30 Agu 2026),
               sudah termasuk kartu tegaknya — dokoyo-sg-hand-match.webp. */
            '<div class="cr-hand" id="rHand"><div class="cr-hand-img"></div></div>'+
          '</div>'+
        '</div>'+
        '<div class="cr-slider-row">'+
          '<input type="range" class="slider" id="rRange" step="0.002">'+
          '<div class="cr-ends">'+(ID
            ? '<span>&larr; kecilkan</span><span>geser aku</span><span>besarkan &rarr;</span>'
            : '<span>&larr; smaller</span><span>drag me</span><span>bigger &rarr;</span>')+'</div>'+
        '</div>'+
        '<div class="cr-foot">'+
          '<div class="cr-foot-nav">'+
            '<button class="btn ghost" id="rBack">&larr; '+(ID?'Kembali':'Back')+'</button>'+
            '<button class="btn" id="rDone">'+(ID?'Selesai':'Done')+'</button>'+
            '<button class="btn" id="rMatch">'+(ID
              ? 'Sudah pas &mdash; lanjut' : 'It matches &mdash; continue')+'</button>'+
          '</div>'+
          '<button class="link" id="rFix">'+(ID
            ? 'Kotaknya sudah tidak pas dengan kartumu? Betulkan'
            : 'Box doesn\'t match your card any more? Fix it')+'</button>'+
        '</div>'+
      '</div>');

    var wrap  = document.getElementById('rWrap'),
        stage = document.getElementById('rStage'),
        card  = document.getElementById('rCard'),
        line  = document.getElementById('rLine'),
        fill  = document.getElementById('rFill'),
        read  = document.getElementById('rRead'),
        tag   = document.getElementById('rTag'),
        rng   = document.getElementById('rRange');
    var adjusting = false;

    /* Kartu tidak selalu muat penuh: di jendela pendek bagian bawahnya terpotong
       (garis putus-putus), dan pencocokan dilakukan lewat LEBAR kotak. */
    function fitsNow(){ return CARD_MM*ppm <= stage.clientHeight; }
    function layout(){
      var f = fitsNow();
      card.classList.toggle('clipped', !f);
      card.style.width  = (CARD_SHORT_MM*ppm)+'px';
      card.style.height = f ? (CARD_MM*ppm)+'px' : '100%';
      /* Sudut kartu asli membulat 3,18 mm (standar ISO) — kotaknya ikut, dan ikut
         membesar-mengecil bersama slider supaya selalu terlihat seperti kartu. */
      var rad = (3.18*ppm).toFixed(1);
      card.style.borderRadius = f ? rad+'px' : rad+'px '+rad+'px 0 0';
    }
    function paint(){
      var localMax = fitsNow() ? CARD_MM : (stage.clientHeight/ppm);
      val = Math.max(0, Math.min(localMax, val));
      var y = val*ppm;
      line.style.top = y+'px';
      fill.style.height = y+'px';
      /* WAJIB innerHTML, bukan textContent: dispFine() mengembalikan lambang pecahan
         dan tanda inci sebagai kode HTML (&frac34;, &quot;). Dengan textContent,
         customer melihat tulisan mentah 0 13/16&quot; di layar. */
      read.innerHTML = dispFine(val);
      tag.innerHTML = dispFine(val);
    }
    function setPhase(adj){
      adjusting = adj;
      wrap.classList.toggle('adjusting', adj);
      if(adj){
        wrap.classList.remove('touched');   /* tangan tampil lagi tiap masuk tahap match */
        base = ppm;
        /* Batas atas slider dihitung dari lebar panggung: kartu yang lebih lebar
           dari layar sisinya hilang dan tidak bisa dicocokkan lagi. */
        var hi = Math.min(1.45, (stage.clientWidth - 4)/(CARD_SHORT_MM*base));
        if(hi < LO + 0.1) hi = LO + 0.1;
        rng.min = LO; rng.max = hi.toFixed(3);
        rng.value = Math.min(1, hi);
        ppm = base*parseFloat(rng.value);
      }
      layout();
      if(!adj) paint();
    }

    /* Tangan bayangan menyingkir SELAMA slider digeser (supaya tidak menghalangi
       pencocokan), lalu kembali 1,5 detik setelah geseran berhenti — permintaan
       Nandha 30 Agu. Ukurannya otomatis mengikuti kotak yang sudah di-adjust,
       karena semua satuannya persen dari kotak itu sendiri. */
    var handTimer;
    rng.addEventListener('input', function(){
      ppm = base*parseFloat(rng.value);
      wrap.classList.add('touched');
      clearTimeout(handTimer);
      handTimer = setTimeout(function(){ wrap.classList.remove('touched'); }, 1500);
      layout();
    });

    function fromY(y){ val = (y - card.getBoundingClientRect().top)/ppm; paint(); }
    var dragging = false;
    stage.addEventListener('pointerdown', function(e){
      if(adjusting) return;            /* saat mencocokkan, garisnya belum ada */
      dragging = true; stage.setPointerCapture(e.pointerId); fromY(e.clientY);
    });
    stage.addEventListener('pointermove', function(e){ if(dragging) fromY(e.clientY); });
    stage.addEventListener('pointerup',   function(){ dragging = false; });
    stage.addEventListener('pointercancel', function(){ dragging = false; });
    document.getElementById('rUp').onclick   = function(){ val = Math.round(val)+1; paint(); };
    document.getElementById('rDown').onclick = function(){ val = Math.round(val)-1; paint(); };

    document.addEventListener('touchmove', blockTouch, {passive:false});
    if(navigator.wakeLock && navigator.wakeLock.request){
      navigator.wakeLock.request('screen').then(function(w){ wakeLock = w; }).catch(function(){});
    }

    var fromFix = false;
    document.getElementById('rMatch').onclick = function(){
      store.ppm = ppm; store.dpr = window.devicePixelRatio; save(store);
      fromFix = false;
      setPhase(false);
    };
    document.getElementById('rFix').onclick = function(){ fromFix = true; setPhase(true); };
    document.getElementById('rBack').onclick = function(){
      /* Back saat memperbaiki lewat "Fix it" membatalkan perbaikan — bukan keluar layar.
         Back di tahap match awal keluar ke layar hitung, seperti biasa. */
      if(adjusting && fromFix){ ppm = store.ppm; fromFix = false; setPhase(false); return; }
      releaseLock(); back();
    };
    document.getElementById('rDone').onclick = function(){
      releaseLock();
      wrap.remove();
      $body.style.display = '';
      go('single', (S.cards*CARD_MM + val)/10);
    };

    /* Tahap match SELALU tampil dulu — keputusan Nandha 30 Agu 2026: ini langkah
       wajib, bukan pilihan. Ukuran tersimpan tinggal dikonfirmasi sekali tekan,
       dan zoom/ganti jendela yang diam-diam mengubah skala ikut tertangkap. */
    setPhase(true);
  }

  /* Cadangan kalau layar terlalu pendek, atau customer memilih jalur cepat.
     Ketelitian turun ke ±1 cm (penggaris ±0,7 cm) — masih cukup di hampir semua kasus. */
  function scEstimate(reason){
    setStep(stepLabel());
    var parts = ID
      ? [['Tidak ada sisa',0],['Seperempat kartu',0.25],['Setengah kartu',0.5],['Tiga perempat kartu',0.75]]
      : [['Nothing',0],['A quarter',0.25],['Half',0.5],['Three quarters',0.75]];
    var bar = '<div style="display:flex;border:2px solid var(--sg-coral);border-radius:8px;'+
      'overflow:hidden;margin:16px 0 6px;background:var(--sg-coral-soft)">'+
      [0,1,2,3].map(function(i){
        return '<div style="flex:1;height:52px;'+(i?'border-left:1px dashed #e0a891':'')+'"></div>';
      }).join('')+'</div>'+
      '<div style="display:flex;font-size:11px;color:var(--sg-ink-soft);margin-bottom:18px">'+
      ['0','&frac14;','&frac12;','&frac34;', ID?'1 kartu':'1 card'].map(function(t,i){
        return '<div style="flex:'+(i===4?'0 0 auto':'1')+';text-align:'+(i?'right':'left')+'">'+t+'</div>';
      }).join('')+'</div>';
    html((reason==='noroom'
        ? '<div class="warn">'+(ID
            ? 'Layar HP-mu terlalu pendek untuk menampilkan penggaris penuh, jadi kita pakai cara cepat saja.'
            : 'Your screen is too short to show a full ruler, so let\'s do this the quick way instead.')+'</div>' : '')+
      (ID
        ? '<h2>Kira-kira sisa talinya berapa?</h2>'+
          '<p>Tempelkan sisa talinya ke kartu, lalu pilih yang paling mendekati.</p>'
        : '<h2>Roughly how much was left over?</h2>'+
          '<p>Hold the leftover bit of string against your card and pick the closest one.</p>')+ bar +
      parts.map(function(p,i){
        return '<button class="btn ghost" id="e'+i+'" style="text-align:left">'+p[0]+'</button>';
      }).join('')+
      '<p class="tiny">'+(ID
        ? 'Cukup akurat untuk menentukan size &mdash; cuma sedikit di bawah penggaris tadi.'
        : 'Close enough for picking a size &mdash; just a touch less precise than the ruler.')+'</p>');
    parts.forEach(function(p,i){
      on('e'+i, function(){ go('single', (S.cards*CARD_MM + p[1]*CARD_MM)/10); });
    });
  }

  function scSingle(cm){
    setStep(stepLabel());
    if(cm < 40 || cm > 200){
      html(ID
        ? '<h2>Hmm, kayaknya ada yang keliru</h2>'+
          '<p>'+disp(cm)+' itu lebih '+(cm<40?'kecil':'besar')+' daripada yang kami perkirakan untuk '+
            LABEL[S.cur].toLowerCase()+'. Ada kartu yang kelewat waktu menghitung?</p>'+
          '<button class="btn" id="b1">Aku hitung ulang</button>'+
          '<button class="btn ghost" id="b2">Tidak, itu sudah benar</button>'
        : '<h2>Hmm, that doesn\'t look right</h2>'+
          '<p>'+disp(cm)+' is '+(cm<40?'smaller':'bigger')+' than we\'d expect for a '+
            LABEL[S.cur].toLowerCase()+'. Miss a card while counting?</p>'+
          '<button class="btn" id="b1">Let me recount</button>'+
          '<button class="btn ghost" id="b2">No, that\'s right</button>');
      on('b1', function(){ go('count'); });
      on('b2', function(){ accept(cm); });
      return;
    }
    /* Pengukuran TERAKHIR tidak berhenti di layar konfirmasi — langsung ke
       rekomendasi ukuran (permintaan Nandha 30 Agu: klik "show my size" cuma
       basa-basi). Hasil + papan kemajuannya ikut ditampilkan di sana lewat
       S.lastResult, dan riwayat dibersihkan supaya tombol Back di layar
       rekomendasi kembali ke penggaris, bukan memantul ke sini. */
    if(!S.queue[1]){
      accept(cm);
      if(S.hist.length && S.hist[S.hist.length-1].name === 'single') S.hist.pop();
      return;
    }
    var nextKey = S.queue[1];
    html('<div class="result"><div class="big">'+both(cm)+'</div>'+
      '<div class="sub">'+(ID
        ? LABEL[S.cur]+' kamu &mdash; itu '+S.cards+' kartu plus '+
          dispFine(cm*10 - S.cards*CARD_MM)+'.'
        : 'Your '+LABEL[S.cur].toLowerCase()+' &mdash; that\'s '+S.cards+
          ' card'+(S.cards===1?'':'s')+' plus '+dispFine(cm*10 - S.cards*CARD_MM)+'.')+'</div></div>'+
      boardHtml(S.cur, cm)+
      (ID
        ? '<button class="btn" id="b1">Sudah pas &mdash; lanjut ukur '+
            LABEL[nextKey].toLowerCase()+'</button>'+
          '<button class="btn ghost" id="b2">Aku mau ulang</button>'
        : '<button class="btn" id="b1">Looks right &mdash; measure my '+
            LABEL[nextKey].toLowerCase()+' next</button>'+
          '<button class="btn ghost" id="b2">Let me redo that</button>'));
    on('b1', function(){ accept(cm); });
    on('b2', function(){ go('measure'); });
  }

  /* Papan kemajuan: kotak terisi + kotak yang masih kosong, berdampingan.
     Permintaan Nandha 30 Agu 2026 — tanpa ini customer mengira semuanya selesai
     setelah ukuran pertama, lalu bingung "kok disuruh ukur lagi?". */
  function boardHtml(cur, cm){
    if(S.chart.need.length < 2) return '';
    return '<div class="mrow">'+S.chart.need.map(function(k){
      var cls, val;
      if(k === cur){ cls = 'now'; val = disp(cm); }
      else if(S.queue.indexOf(k) > -1){ cls = 'todo'; val = ID ? 'berikutnya' : 'up next'; }
      else { cls = 'done'; val = disp(store.m[k]); }
      return '<div class="mtile '+cls+'"><div class="k">'+LABEL[k]+'</div>'+
             '<div class="v">'+val+'</div></div>';
    }).join('')+'</div>';
  }

  function accept(cm){
    store.m[S.cur] = Math.round(cm*10)/10; save(store);
    /* Simpan hasil terakhir supaya layar rekomendasi bisa menampilkannya.
       <= 1 (bukan === 1): lewat tombol Back antreannya sudah kosong saat
       pengukuran terakhir diulang, dan hasilnya tetap harus tampil. */
    if(S.queue.length <= 1) S.lastResult = {key:S.cur, cm:cm, cards:S.cards};
    S.queue.shift();
    if(S.queue.length){ S.cur = S.queue[0]; go('measure'); } else go('final');
  }

  function scFinal(){
    setStep('');
    /* Kalau baru saja tiba dari pengukuran terakhir: tampilkan hasilnya + papan
       kemajuan DI ATAS rekomendasi, jadi satu layar utuh tanpa klik ekstra. */
    var lr = S.lastResult; S.lastResult = null;
    var c = S.chart, need = c.need, vals = {}, idxs = {}, oo = null;
    for(var i=0;i<need.length;i++){
      var k = need[i], v = store.m[k];
      if(v == null) continue;
      vals[k] = v;
      var o = outOfRange(c,k,v);
      if(o && !oo) oo = {key:k, dir:o, cm:v};   /* laporkan yang pertama, bukan yang terakhir */
      idxs[k] = sizeIndex(c,k,v);
    }
    if(oo) return scOutOfRange(oo);
    var keys = Object.keys(idxs);
    if(!keys.length) return go('manual');

    var list = keys.map(function(k){ return idxs[k]; });
    var hi = Math.max.apply(null,list), lo = Math.min.apply(null,list);
    var pick = c.sizes[hi];
    var meta = keys.map(function(k){ return LABEL[k]+' '+disp(vals[k]); }).join(' · ');
    if(!sizeAvail(pick)) return scNoSize(pick, meta);
    var body;

    if(hi - lo >= 2){
      var kLo = keys.filter(function(k){ return idxs[k]===lo; })[0];
      var kHi = keys.filter(function(k){ return idxs[k]===hi; })[0];
      body = (ID
        ? '<h2>Ukuranmu ada di antara dua size. Ini jujurnya.</h2>'+
          '<p>'+LABEL[kLo]+' kamu ukurannya <b>'+c.sizes[lo]+'</b>. '+
            LABEL[kHi]+' kamu ukurannya <b>'+c.sizes[hi]+'</b>.</p>'+   /* dua kalimat terpisah, jadi keduanya boleh kapital */
          '<p>Ambil <b>'+c.sizes[hi]+'</b> kalau mau tertutup penuh &mdash; '+
            'ada bagian yang agak longgar, tapi tidak ada yang ketarik.</p>'+
          '<p>Ambil <b>'+c.sizes[lo]+'</b> kalau suka yang lebih ngepas &mdash; tapi memang pas banget.</p>'
        : '<h2>You\'re between sizes. Here\'s the honest version.</h2>'+
          '<p>Your '+LABEL[kLo].toLowerCase()+' '+verb(kLo)+' <b>'+c.sizes[lo]+'</b>. '+
            'Your '+LABEL[kHi].toLowerCase()+' '+verb(kHi)+' <b>'+c.sizes[hi]+'</b>.</p>'+
          '<p>Go <b>'+c.sizes[hi]+'</b> for full coverage &mdash; it\'ll sit loose in places, '+
            'but nothing will pull.</p>'+
          '<p>Go <b>'+c.sizes[lo]+'</b> for a snugger fit &mdash; just know it\'ll be close.</p>')+
        '<p class="quiet">'+meta+'</p>';
    } else if(hi - lo === 1){
      var kS = keys.filter(function(k){ return idxs[k]===lo; })[0];
      var kB = keys.filter(function(k){ return idxs[k]===hi; })[0];
      body = '<div class="sizebox"><div class="lbl">'+(ID?'Saran kami':'We\'d say')+
          '</div><div class="size">'+pick+'</div></div>'+
        (ID
          ? '<p>'+LABEL[kS]+' kamu ukurannya '+c.sizes[lo]+', '+
              LABEL[kB].toLowerCase()+' kamu ukurannya '+c.sizes[hi]+
              '. Kami pilih yang lebih besar &mdash; lebih enak ada ruang di tempat yang kamu butuhkan.</p>'
          : '<p>Your '+LABEL[kS].toLowerCase()+' '+verb(kS)+' '+c.sizes[lo]+', your '+
              LABEL[kB].toLowerCase()+' '+verb(kB)+' '+c.sizes[hi]+
              '. We went with the bigger one &mdash; better to have room where you need it.</p>')+
        '<p class="quiet">'+meta+'</p>';
    } else {
      var gk = null, e = null;
      for(var j=0;j<keys.length && !e;j++){ gk = keys[j]; e = edge(c,gk,vals[gk],hi); }
      if(e === 'up' && hi < c.sizes.length-1){
        body = '<div class="sizebox"><div class="lbl">Size</div><div class="size">'+pick+'</div>'+
            '<div class="lbl">'+(ID?'tapi mepet batas atas':'but only just')+'</div></div>'+
          (ID
            ? '<p>Ukuranmu pas di batas paling atas '+pick+'.</p>'+
              '<p>Suka yang ngepas? <b>'+pick+'</b>.<br>Mau agak longgar? <b>'+c.sizes[hi+1]+'</b>.</p>'
            : '<p>You\'re sitting right at the top of '+pick+'.</p>'+
              '<p>Like it snug? <b>'+pick+'</b>.<br>Want a bit of room? <b>'+c.sizes[hi+1]+'</b>.</p>')+
          '<p class="quiet">'+meta+'</p>';
      } else if(e === 'down' && hi > 0){
        body = '<div class="sizebox"><div class="lbl">Size</div><div class="size">'+pick+'</div>'+
            '<div class="lbl">'+(ID?'di sisi longgarnya':'at the roomy end')+'</div></div>'+
          (ID
            ? '<p>Ukuranmu pas di batas paling bawah '+pick+'.</p>'+
              '<p>Suka yang ngepas? <b>'+c.sizes[hi-1]+'</b>.<br>Mau agak longgar? <b>'+pick+'</b>.</p>'
            : '<p>You\'re right at the bottom of '+pick+'.</p>'+
              '<p>Like it snug? <b>'+c.sizes[hi-1]+'</b>.<br>Want a bit of room? <b>'+pick+'</b>.</p>')+
          '<p class="quiet">'+meta+'</p>';
      } else {
        body = '<div class="sizebox"><div class="lbl">'+(ID?'Size kamu':'You\'re a size')+
            '</div><div class="size">'+pick+'</div></div>'+
          '<p class="quiet">'+meta+'<br>'+(ID
            ? 'Berdasarkan tabel size '+c.label+'.'
            : 'Based on the '+c.label+' chart.')+'</p>';
      }
    }

    var head = '', redo = '';
    if(lr){
      head = '<div class="result"><div class="big">'+both(lr.cm)+'</div>'+
        '<div class="sub">'+(ID
          ? LABEL[lr.key]+' kamu &mdash; itu '+lr.cards+' kartu plus '+
            dispFine(lr.cm*10 - lr.cards*CARD_MM)+'.'
          : 'Your '+LABEL[lr.key].toLowerCase()+' &mdash; that\'s '+lr.cards+
            ' card'+(lr.cards===1?'':'s')+' plus '+dispFine(lr.cm*10 - lr.cards*CARD_MM)+'.')+
        '</div></div>'+boardHtml(lr.key, lr.cm);
      redo = '<button class="link" id="b3">'+(ID
        ? 'Ukur ulang '+LABEL[lr.key].toLowerCase()
        : 'Redo my '+LABEL[lr.key].toLowerCase())+' &rarr;</button>';
    }
    html(head+body+'<button class="btn" id="b1">'+(ID?'Oke, paham':'Got it')+'</button>'+
      '<div class="links">'+redo+'<button class="link" id="b2">'+
        (ID?'Ukur ulang':'Measure again')+' &rarr;</button></div>'+
      '<p class="tiny">'+(ID
        ? 'Ini saran, bukan janji. Badan orang memang rumit.<br>'+
          'Ukuran kamu tidak pernah keluar dari HP ini. Kami tidak bisa melihatnya.'
        : 'A recommendation, not a promise. Bodies are complicated.<br>'+
          'Your measurements never leave this device. We don\'t see them.')+'</p>');
    on('b1', close);
    on('b2', function(){ S.queue = c.need.slice(); S.cur = S.queue[0]; go('measure'); });
    if(lr) on('b3', function(){ S.queue = [lr.key]; S.cur = lr.key; go('measure'); });
  }

  /* Ukurannya ada di tabel, tapi variannya tidak dijual di produk ini.
     Jujur di muka lebih murah daripada retur — pola yang sama dengan scOutOfRange. */
  function scNoSize(pick, meta){
    setStep('');
    html((ID
      ? '<h2>Maaf &mdash; size kamu belum ada di model ini</h2>'+
        '<p>Dari ukuranmu, size-nya <b>'+pick+'</b>, dan model ini '+
          'untuk sekarang belum tersedia dalam '+pick+'.</p>'+
        '<p>Chat kami &mdash; nanti kami kabari kalau stoknya balik, '+
          'atau kami tunjukkan model lain yang muat.</p>'
      : '<h2>Sorry &mdash; we don\'t have your size in this one</h2>'+
        '<p>Your measurements point to '+art(pick)+' <b>'+pick+'</b>, and this style '+
          'doesn\'t come in '+pick+' at the moment.</p>'+
        '<p>Message us &mdash; we\'ll tell you if it\'s on the way back, '+
          'or point you to a style that does fit.</p>')+
      (meta ? '<p class="quiet">'+meta+'</p>' : '')+
      '<button class="btn" id="b1">'+(ID?'Chat dengan kami':'Chat with us')+'</button>'+
      '<div class="links"><button class="link" id="b2">'+
        (ID?'Ukur ulang':'Measure again')+' &rarr;</button></div>');
    on('b1', chat);
    on('b2', function(){ S.queue = S.chart.need.slice(); S.cur = S.queue[0]; go('measure'); });
  }

  function scOutOfRange(oo){
    var c = S.chart, r = c.raw[oo.key];
    html((ID
      ? '<h2>Aduh &mdash; ukuranmu sedikit di luar jangkauan kami</h2>'+
        '<p>'+LABEL[oo.key]+' '+disp(oo.cm)+'<br>Size '+(oo.dir==='over'?'terbesar':'terkecil')+
          ' di model ini '+(oo.dir==='over'?'berhenti di '+disp(r[1]):'mulai dari '+disp(r[0]))+'.</p>'+
        '<p>Kami lebih baik bilang sekarang daripada kamu harus kirim balik. '+
          'Chat kami, nanti kami arahkan ke yang lebih cocok.</p>'+
        '<button class="btn" id="b1">Oke, paham</button>'+
        '<div class="links"><button class="link" id="b2">Chat dengan kami &rarr;</button></div>'
      : '<h2>Ah &mdash; you\'re just outside our range</h2>'+
        '<p>'+LABEL[oo.key]+' '+disp(oo.cm)+'<br>Our '+(oo.dir==='over'?'biggest':'smallest')+
          ' size in this style '+(oo.dir==='over'?'stops at '+disp(r[1]):'starts at '+disp(r[0]))+'.</p>'+
        '<p>We\'d rather say so now than have you post it back. '+
          'Message us and we\'ll point you somewhere better.</p>'+
        '<button class="btn" id="b1">Got it</button>'+
        '<div class="links"><button class="link" id="b2">Chat with us &rarr;</button></div>'));
    on('b1', close); on('b2', chat);
  }

  /* Shopify Inbox: tutup popup DULU baru panggil chat — kalau tidak, jendela chat
     muncul di belakang popup dan customer mengira tombolnya rusak.
     Kalau widget-nya tidak ada, jatuh ke halaman kontak; jangan diam saja. */
  function chat(){
    close();
    setTimeout(function(){
      /* Shopify Inbox 2026: elemen <shopify-chat> dengan tombol pembuka di dalam
         shadow DOM — diverifikasi langsung di dokoyo.com 30 Agu 2026. Deteksi
         lama (window.ShopifyChat dkk.) dipertahankan sebagai cadangan saja. */
      var sc = document.querySelector('shopify-chat');
      if(sc && sc.shadowRoot){
        var t = sc.shadowRoot.querySelector('button');
        if(t){ t.click(); return; }
      }
      if(window.ShopifyChat && window.ShopifyChat.open){ window.ShopifyChat.open(); return; }
      var b = document.querySelector('#ShopifyChat, [id*="shopify-chat"], .shopify-chat-button');
      if(b){ b.click(); return; }
      window.location.href = CONTACT_URL;
    }, 260);
  }

  function scManual(){
    setStep('');
    var rows = S.chart.need.map(function(k){
      var v = store.m[k]!=null ? Math.round(fromCm(store.m[k])*10)/10 : '';
      return '<div class="row"><label class="fld" for="mi_'+k+'">'+LABEL[k]+' ('+unitLabel()+')</label>'+
             '<input type="number" inputmode="decimal" step="0.5" id="mi_'+k+'" value="'+v+'" placeholder="'+unitLabel()+'"></div>';
    }).join('');
    html((ID?'<h2>Ketik ukuran yang kamu tahu</h2>':'<h2>Type in what you know</h2>')+rows+
      '<p class="quiet">'+(ID
        ? 'Kosongkan saja kalau tidak yakin &mdash; kami olah dari yang ada.'
        : 'Leave one blank if you\'re not sure &mdash; we\'ll work with what we\'ve got.')+'</p>'+
      '<p class="quiet" id="mWarn" style="display:none;color:#a34426">'+(ID
        ? 'Isi minimal satu ukuran dulu ya.' : 'Pop in at least one measurement.')+'</p>'+
      '<button class="btn" id="b1">'+(ID?'Cari size aku':'Find my size')+'</button>');
    on('b1', function(){
      var any = false;
      S.chart.need.forEach(function(k){
        var n = parseFloat(document.getElementById('mi_'+k).value);
        if(!isNaN(n) && n>0){ store.m[k] = Math.round(toCm(n)*10)/10; any = true; }
      });
      if(!any){ document.getElementById('mWarn').style.display=''; return; }
      save(store); go('final');
    });
  }

  function scReturning(){
    setStep('');
    var c = S.chart;
    var idxs = c.need.map(function(k){ return sizeIndex(c,k,store.m[k]); });
    var pick = c.sizes[Math.max.apply(null, idxs)];
    var meta = c.need.map(function(k){ return LABEL[k]+' '+disp(store.m[k]); }).join(' · ');
    if(!sizeAvail(pick)) return scNoSize(pick, meta);
    html((ID
        ? '<h2>Selamat datang lagi &mdash; di model ini size kamu '+pick+'</h2>'
        : '<h2>Welcome back &mdash; you\'re '+art(pick)+' '+pick+' in this one</h2>')+
      '<div class="sizebox"><div class="lbl">'+(ID?'Size kamu':'Your size')+
        '</div><div class="size">'+pick+'</div></div>'+
      '<p class="quiet">'+(ID
        ? 'Dari ukuran yang kamu simpan:' : 'From the measurements you saved:')+'<br>'+meta+'</p>'+
      '<button class="btn" id="b1">'+(ID?'Oke, paham':'Got it')+'</button>'+
      '<div class="links"><button class="link" id="b2">'+
          (ID?'Ukur ulang':'Measure again')+' &rarr;</button>'+
        '<button class="link" id="b3">'+(ID
          ? 'Lihat rinciannya' : 'See the full breakdown')+' &rarr;</button></div>');
    on('b1', close);
    on('b2', function(){ S.queue = c.need.slice(); S.cur = S.queue[0]; go('string'); });
    on('b3', function(){ go('final'); });
  }

  function scPartial(){
    setStep('');
    var missing = S.chart.need.filter(function(k){ return store.m[k]==null; });
    var dan = ID ? ' dan ' : ' and ';
    var have = S.chart.need.filter(function(k){ return store.m[k]!=null; })
                 .map(function(k){ return LABEL[k].toLowerCase(); }).join(dan);
    var perlu = missing.map(function(k){ return LABEL[k].toLowerCase(); }).join(dan);
    html(ID
      ? '<h2>Sedikit lagi</h2>'+
        '<p>Ukuran '+have+' kamu sudah ada. Model ini juga perlu ukuran '+perlu+'.<br>'+
          (missing.length===1 ? 'Satu ukuran saja, sekitar satu menit.' : 'Tidak akan lama kok.')+'</p>'+
        '<button class="btn" id="b1">Ukur '+LABEL[missing[0]].toLowerCase()+'</button>'
      : '<h2>Almost there</h2>'+
        '<p>We\'ve got your '+have+'. This one also needs your '+perlu+'.<br>'+
          (missing.length===1 ? 'One measurement, about a minute.' : 'Shouldn\'t take long.')+'</p>'+
        '<button class="btn" id="b1">Measure my '+LABEL[missing[0]].toLowerCase()+'</button>');
    on('b1', function(){ S.queue = missing.slice(); S.cur = S.queue[0]; go('string'); });
  }

  /* ---------------------------------------------------------------------
     HALAMAN "FIND MY SIZE" TERSENDIRI (menu atas)
     Grid ikon bentuk produk → pilih model → alur ukur yang sama persis.
     Karena ukuran disimpan per BAGIAN BADAN (bukan per produk), sekali ukur
     membuat model lain ikut terjawab: grid berubah jadi daftar "kamu size
     berapa di tiap model", dan halaman produk mana pun langsung menyapa
     "Welcome back". Itu alasan utama halaman ini ada.
  --------------------------------------------------------------------- */

  /* Siluet garis, satu gaya, semua di kanvas 64x64 supaya sejajar rapi.
     Sengaja sederhana — ini penanda bentuk, bukan gambar produk. */
  var ICON = {
    hipster:'<path d="M12 20h40l-3 12c-1 5-4 8-7 12l-4 6c-2 3-6 3-7-1l-3-9-3 9c-1 4-5 4-7 1l-4-6c-3-4-6-7-7-12z"/>',
    thong:'<path d="M14 20h36l-2 10c-1 4-4 6-6 9l-8 12c-2 3-6 3-8 0l-8-12c-2-3-5-5-6-9z"/>',
    midwaist:'<path d="M11 14h42l-3 19c-1 5-4 8-7 12l-4 6c-2 3-6 3-7-1l-3-9-3 9c-1 4-5 4-7 1l-4-6c-3-4-6-7-7-12z"/><path d="M11 22h42" stroke-dasharray="3 3"/>',
    highwaist:'<path d="M10 8h44l-4 26c-1 5-4 8-7 12l-4 6c-2 3-6 3-7-1l-2-9-3 9c-1 4-5 4-7 1l-4-6c-3-4-6-7-7-12z"/><path d="M10 17h44" stroke-dasharray="3 3"/>',
    /* Bralette: dua mangkuk setengah lingkaran menggantung di ban, plus tali bahu.
       Versi pertama (dua lengkung menyatu) terbaca seperti KACAMATA — mangkuknya
       harus benar-benar bulat penuh dan talinya panjang supaya jelas ini bra. */
    bralette:'<path d="M6 26h52"/><path d="M6 26a13 13 0 0 0 26 0"/><path d="M32 26a13 13 0 0 0 26 0"/>'+
             '<path d="M32 26v5"/><path d="M10 26L19 9M54 26L45 9"/>',
    /* Tube bra: ban polos tanpa tali — itu ciri pembedanya dari bralette. */
    tubebra:'<path d="M10 22q22-7 44 0v13c0 6-4 10-10 10H20c-6 0-10-4-10-10z"/>'+
            '<path d="M10 30q22-6 44 0" stroke-dasharray="3 3"/>'
  };
  var PICK_ORDER = ['hipster','thong','midwaist','highwaist','bralette','tubebra'];

  /* Daftar model yang tampil di grid. Bisa diatur dari Theme Editor: section
     mengirim JSON lewat atribut data-styles pada elemen host, satu entri per
     blok — {chart, label, img}. Kalau tidak ada, pakai keenam bawaan di atas.
     `img` = URL gambar ikon dari Nandha; kalau kosong, pakai siluet SVG bawaan. */
  function styleList(){
    if(S.styles && S.styles.length) return S.styles;
    return PICK_ORDER.map(function(k){ return {chart:k, label:CHARTS[k].label, img:''}; });
  }
  function readStyles(host){
    S.styles = null;
    var raw = host && host.getAttribute('data-styles');
    if(!raw) return;
    try{
      var list = JSON.parse(raw).filter(function(x){ return x && CHARTS[x.chart]; });
      if(list.length) S.styles = list.map(function(x){
        return {chart:x.chart, label:x.label || CHARTS[x.chart].label, img:x.img || ''};
      });
    }catch(e){}   /* JSON rusak → diam-diam pakai bawaan, jangan kosongkan halaman */
  }

  /* Semua bagian badan yang mungkin dipakai model mana pun — untuk isian manual
     di awal, sebelum model dipilih. Urutannya dari atas badan ke bawah. */
  var ALL_PARTS = ['bust','underbust','waist','hips'];

  /* Ukuran yang SUDAH bisa dijawab dari ukuran tersimpan — null kalau belum */
  function knownSize(key){
    var c = CHARTS[key];
    for(var i=0;i<c.need.length;i++) if(store.m[c.need[i]] == null) return null;
    var idxs = c.need.map(function(k){ return sizeIndex(c,k,store.m[k]); });
    return c.sizes[Math.max.apply(null, idxs)];
  }

  function showPicker(){
    S.screen = null; S.hist = []; S.avail = null;
    var fresh = load(); if(fresh && fresh.m) store = fresh;
    if(!store.m) store.m = {};
    $sg.classList.add('on'); $top.style.display='none'; $body.style.display='';

    var any = false;
    var cards = styleList().map(function(st){
      var k = st.chart, got = knownSize(k); if(got) any = true;
      var art = st.img
        ? '<img class="pick-ic" src="'+st.img+'" alt="" loading="lazy">'
        : '<svg class="pick-ic" viewBox="0 0 64 64" fill="none" stroke="currentColor" '+
          'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+
          ICON[k]+'</svg>';
      return '<button type="button" class="pick" data-pick="'+k+'">'+ art +
        '<span class="pick-name">'+st.label+'</span>'+
        '<span class="pick-size'+(got?'':' none')+'">'+
          (got ? got : (ID ? 'ukur' : 'measure'))+'</span>'+
      '</button>';
    }).join('');

    html('<h2>'+(ID
        ? (any ? 'Size kamu di Dokoyo' : 'Kamu lagi cari yang mana?')
        : (any ? 'Your sizes at Dokoyo' : 'Which one are you after?'))+'</h2>'+
      '<p class="quiet">'+(ID
        ? (any
          ? 'Dari ukuran yang tersimpan di HP ini. Pilih salah satu untuk lihat rinciannya, atau ukur ulang.'
          : 'Pilih satu model, nanti kami hitung pakai seutas tali dan kartu ATM. '+
            'Sekali ukur &mdash; model lainnya ikut terjawab sendiri.')
        : (any
          ? 'From the measurements saved on this device. Pick one to see the details, or measure again.'
          : 'Pick a style and we\'ll work it out with a piece of string and a bank card. '+
            'Measure once &mdash; every other style fills itself in.'))+'</p>'+
      /* data-n dipakai CSS untuk memilih jumlah kolom yang paling seimbang */
      '<div class="pickgrid" data-n="'+styleList().length+'">'+cards+'</div>'+
      /* Jalan pintas ini dulu tautan kecil dan luput dari mata. Sekarang kartu
         dengan bentuk yang sama seperti model — tapi SENGAJA dipisah di bawah
         dan di tengah, supaya tidak terbaca sebagai model ketujuh. */
      '<div class="pickalt">'+
        '<button type="button" class="pick pick-alt" id="pKnow">'+
          '<svg class="pick-ic" viewBox="0 0 64 64" fill="none" stroke="currentColor" '+
            'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+
            '<path d="M12 52h40"/>'+
            '<path d="M20 44l22-22 6 6-22 22h-6z"/>'+
            '<path d="M42 22l4-4a4 4 0 016 0l0 0a4 4 0 010 6l-4 4"/>'+
          '</svg>'+
          '<span class="pick-name">'+(ID
            ? 'Aku sudah tahu ukuranku' : 'I already know my measurements')+'</span>'+
          '<span class="pick-size none">'+(ID?'ketik di sini':'type them in')+'</span>'+
        '</button>'+
      '</div>'+
      (any ? '<div class="links"><button class="link" id="pReset">'+(ID
        ? 'Hapus ukuranku' : 'Clear my measurements')+' &rarr;</button></div>' : '')+
      '<p class="tiny">'+(ID
        ? 'Ukuran kamu tidak pernah keluar dari HP ini. Kami tidak bisa melihatnya.'
        : 'Your measurements never leave this device. We don\'t see them.')+'</p>');

    [].forEach.call($body.querySelectorAll('[data-pick]'), function(b){
      b.onclick = function(){ open(b.getAttribute('data-pick')); };
    });
    on('pKnow', pageManual);
    on('pReset', function(){
      try{ localStorage.removeItem(KEY); }catch(e){}
      store = {m:{}}; showPicker();
    });
  }

  /* Isian manual DI HALAMAN, sebelum model dipilih. Bedanya dengan scManual:
     di sini belum ada model, jadi yang ditanyakan SEMUA bagian badan sekaligus
     dan semuanya boleh dikosongkan. Sekali diisi, seluruh grid ikut terjawab. */
  function pageManual(){
    $top.style.display = 'none';
    var rows = ALL_PARTS.map(function(k){
      var v = store.m[k]!=null ? Math.round(fromCm(store.m[k])*10)/10 : '';
      return '<div class="row"><label class="fld" for="mi_'+k+'">'+LABEL[k]+' ('+unitLabel()+')</label>'+
             '<input type="number" inputmode="decimal" step="0.5" id="mi_'+k+'" value="'+v+
             '" placeholder="'+unitLabel()+'"></div>';
    }).join('');
    html((ID?'<h2>Ketik ukuran yang kamu tahu</h2>':'<h2>Type in what you know</h2>')+
      '<p class="quiet">'+(ID
        ? 'Isi yang kamu tahu, sisanya kosongkan saja &mdash; '+
          'tiap ukuran yang kamu isi membuka model yang membutuhkannya.'
        : 'Fill in what you have and leave the rest blank &mdash; '+
          'each one you add unlocks the styles that need it.')+'</p>'+
      rows+
      '<p class="quiet" id="mWarn" style="display:none;color:#a34426">'+(ID
        ? 'Isi minimal satu ukuran dulu ya.' : 'Pop in at least one measurement.')+'</p>'+
      '<div class="sg-nav">'+
        '<button class="btn" id="b1">'+(ID?'Tampilkan size aku':'Show my sizes')+'</button>'+
        '<button class="btn ghost sg-navback" id="b2">&larr; '+(ID?'Kembali':'Back')+'</button>'+
      '</div>');
    on('b1', function(){
      var any = false;
      ALL_PARTS.forEach(function(k){
        var el = document.getElementById('mi_'+k), n = parseFloat(el.value);
        if(!isNaN(n) && n>0){ store.m[k] = Math.round(toCm(n)*10)/10; any = true; }
        else if(el.value === ''){ delete store.m[k]; }   /* dikosongkan = dihapus */
      });
      if(!any){ document.getElementById('mWarn').style.display=''; return; }
      save(store); showPicker();
    });
    on('b2', showPicker);
  }

  /* pasang otomatis ke tombol mana pun yang punya data-dokoyo-size-guide */
  function wire(){
    document.addEventListener('click', function(e){
      var t = e.target.closest && e.target.closest('[data-dokoyo-size-guide]');
      if(!t) return;
      e.preventDefault();
      open(t.getAttribute('data-chart') || 'hipster', t.getAttribute('data-sizes'));
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();

  /* Halaman tersendiri memanggil ini; elemen host disediakan section Liquid. */
  function mountPage(host){
    if(!host) return;
    build(host);
    readStyles(host);
    showPicker();
  }
  function autoMount(){
    var h = document.querySelector('[data-dokoyo-size-guide-page]');
    if(h) mountPage(h);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoMount);
  else autoMount();

  window.DokoyoSizeGuide = {
    open: open,
    mount: mountPage,
    charts: Object.keys(CHARTS),
    reset: function(){ try{ localStorage.removeItem(KEY); }catch(e){} store = {m:{}}; }
  };
})();
